const CloseIcon: React.FC<React.SVGAttributes<{}>> = ({ ...rest }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...rest}>
      <path
        d="M17.071 15.6564L11.4143 9.9996L17.0712 4.3427C17.4614 3.95247 17.4614 3.31881 17.071 2.92845C16.6808 2.53821 16.0471 2.53821 15.6569 2.92845L10 8.58534L4.3431 2.92845C3.95286 2.53821 3.31921 2.53821 2.92898 2.92845C2.53861 3.31881 2.53861 3.95247 2.92885 4.3427L8.58574 9.9996L2.92898 15.6564C2.53861 16.0467 2.53861 16.6804 2.92885 17.0706C3.31921 17.461 3.95286 17.461 4.34323 17.0706L10 11.4139L15.6568 17.0706C16.0471 17.461 16.6808 17.461 17.0712 17.0706C17.4614 16.6804 17.4614 16.0467 17.071 15.6564Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0"
      />
    </svg>
  );
};

export default CloseIcon;
